import { lazyWithRetries } from '@globals/lazyWithRetries'
import StandardPageLayout from '@layouts/standardPageLayout'
import RouteLoading from '@shared/routing/RouteLoading'
import { T } from '@transifex/react'
import { Suspense } from 'react'
import { RouteObject } from 'react-router'

const DashboardRoute = lazyWithRetries(() => import('./index'))

const routes: RouteObject[] = [
  {
    path: 'dashboard',
    element: (
      <StandardPageLayout maxWidth={1080} elementId="dashboardRoute" title={<T _str="Dashboard" />}>
        <Suspense fallback={<RouteLoading />}>
          <DashboardRoute />
        </Suspense>
      </StandardPageLayout>
    ),
  },
]

export default routes
